export default __webpack_public_path__ + "assets/cross-line.0c239c28.svg";